/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * Service for store and retrieve an specific locale setting.
 *
 * This service is used by map instances, widgets and services to store their locale
 * configuration.
 *
 * If its constructor receive a LocaleService instance as argument it will start listen changes in the
 * given instance and apply the same change in its own. That behavior allows the instances of this class to
 * be updated in cascade.
 *
 * @example
 * ```js
 * // Will use the global LocaleService
 * // You can obtain the global LocaleService calling tomtom.globalLocaleService()
 * tomtom.nearbySearch()
 *   .go()
 *
 * // Will ignore the global LocaleService and use the provided language
 * tomtom.nearbySearch()
 *   .language('pl-PL')
 *   .go();
 *
 * // Example how to use locales which are set per map instance
 * var mapLanguage = mapInstance.getLocaleService().getCurrentLocale();
 * tomtom.nearbySearch()
 *   .language(mapLanguage)
 *   .go();
 * ```
 *
 * @class LocaleService
 * @module Services
 * @extends L.Evented
 * @constructor
 * @param {LocaleService} [parent] If is defined makes the new instance a "slave" of the given instance
 */
define(['./locale', 'leaflet', './languageTypesMapping', 'services/utils'],
    function(Locale, L, languageTypesMapping, Utils) {
        'use strict';
        var allLocales, trafficLocales, routingLocales, searchLocales, mapsLocales, LocaleService, EVENTS;
        var langsToIgnoreInAllSelector = ['NGT', 'NGT-Latn'];

        function createLocaleArrays(serviceType) {
            var prop, langType;
            var result = [];
            for (prop in languageTypesMapping) {
                if (languageTypesMapping.hasOwnProperty(prop)) {
                    langType = languageTypesMapping[prop];

                    if ((!serviceType && langsToIgnoreInAllSelector.indexOf(prop) === -1) ||
                        (langType[serviceType] && langType[serviceType].isNative === true)) {

                        result.push(new Locale(prop));
                    }
                }
            }
            return result.sort(function(a, b) {
                return a.getLabel().localeCompare(b.getLabel());
            });
        }

        allLocales = createLocaleArrays(null);
        trafficLocales = createLocaleArrays('traffic');
        routingLocales = createLocaleArrays('routing');
        searchLocales = createLocaleArrays('search');
        mapsLocales = createLocaleArrays('maps');

        EVENTS = {
            /**
             * Fired after the locale was changed.
             * @event LOCALE_CHANGED
             * @type String
             * 
             * @example
             * ```javascript
             * var localeService = new LocaleService();
             * localeService.on(L.LocaleService.Events.LOCALE_CHANGED, function(eventData) {
             *  console.log(eventData);  
             * });
             * ```
             */
            'LOCALE_CHANGED': 'config.locale.changed'
        };

        function localeChangedHandler(locale) {
            this.setCurrentLocale(locale.getLanguageCode());
        }

        LocaleService = L.Evented.extend({

            Events: EVENTS,

            initialize: function(parent) {
                if (parent instanceof LocaleService) {
                    this.currentLocale = new Locale(parent.getCurrentLocale().getLanguageCode());
                    this.parent = parent;
                    parent.on(EVENTS.LOCALE_CHANGED, localeChangedHandler, this);
                } else {
                    this.currentLocale = new Locale('en-GB');
                }
            },

            /**
             * Sets locale used by a service instance.
             *
             * Fires the event {{#crossLink "LocaleService/LOCALE_CHANGED:event"}}{{/crossLink}}.
             *
             * @method setCurrentLocale
             * @param {String|Locale} [locale="en-GB"] String (with language code) or Locale instance
             */
            setCurrentLocale: function(locale) {
                if (!(locale instanceof Locale)) {
                    this.currentLocale = new Locale(locale);
                } else {
                    this.currentLocale = locale;
                }
                this.fire(EVENTS.LOCALE_CHANGED, this.currentLocale);
            },

            /**
             * Returns the current locale.
             *
             * @method getCurrentLocale
             * @return {Locale}
             */
            getCurrentLocale: function() {
                return this.currentLocale;
            },

            cleanEvents: function() {
                this.parent.off(EVENTS.LOCALE_CHANGED, localeChangedHandler, this);
                this.off();
            }
        });

        LocaleService.Events = EVENTS;
        Utils.addDeprecatedProperty(LocaleService.prototype, 'EVENTS', 'Events');

        /**
         * Static method that returns an array with the supported locales which are supported by given
         * service type.
         *
         * @static
         * @method LocaleService.getLocalesFor
         * @param {"traffic"|"routing"|"search"|"maps"} [serviceType=null]
         * @return {Locale[]}
         */
        LocaleService.getLocalesFor = function(serviceType) {
            switch (serviceType) {
            case 'traffic':
                return trafficLocales;
            case 'routing':
                return routingLocales;
            case 'search':
                return searchLocales;
            case 'maps':
                return mapsLocales;
            default:
                return allLocales;
            }
        };

        L.LocaleService = LocaleService;

        L.localeService = function(parent) {
            return new LocaleService(parent);
        };
        return L.localeService;
    });



// WEBPACK FOOTER //
// ./config/language/localeService.js